import React from "react"
import { Route, Routes } from "react-router-dom"
import { ReportFilterContextProvider } from "../context/ReportFilterContext"
import NotFound from "../features/notFound/pages/NotFound"
import { SettingsScreen } from '../features/settings/components/SettingsScreen'

export const SettingsRoutes = () => {
    return (
      <ReportFilterContextProvider>
        <Routes>
          <Route path="account/*" element={<SettingsScreen />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ReportFilterContextProvider>
    )
}